const datedTasks = {    
    "2025-12-24": { 9:  { text: "wake up in Thailand" },
                    19: { text: "use Stubhub Chase Sapphire $150 credit for Sumo wrestling @ Ryogoku Kokugikan or Black Pink, Tokyo, Japan", tags: ["dumb rich"] },
                    20: { text: "use $250 credit for The Edit Chase Sapphire Reserve", tags: ["dumb rich"] },
                    21: { text: "film stocks part 2 update for Youtube", tags: ["motion"] } },
    "2025-12-25": { 9:  { text: "wake up in Thailand" },
                    18: { text: "film stocks part 2 update for Youtube", tags: ["motion"] } },
    "2025-12-26": { 9:  { text: "wake up in Thailand" },
                    18: { text: "film stocks part 2 update for Youtube", tags: ["motion"] } },
    "2025-12-27": { 9:  { text: "wake up in Thailand" },
                    18: { text: "film stocks part 2 update for Youtube", tags: ["motion"] } },
    "2025-12-28": { 9:  { text: "wake up in Thailand" },
                    18: { text: "film stocks part 2 update for Youtube", tags: ["motion"] },
                    19: { text: "release song that gets 10,000 listens", tags: ["motion"] }, },
    "2025-12-28": { 9:  { text: "wake up in Thailand" },
                    18: { text: "film stocks part 2 update for Youtube", tags: ["motion"] } },
    "2025-12-29": { 9:  { text: "wake up in Thailand" },
                    18: { text: "film stocks part 2 update for Youtube", tags: ["motion"] } },
    "2025-12-30": { 9:  { text: "wake up in Thailand" },
                    18: { text: "film stocks part 2 update for Youtube", tags: ["motion"] } },
    "2025-12-31": { 9:  { text: "wake up in Thailand" },
                    18: { text: "film stocks part 2 update for Youtube", tags: ["motion"] } },
    "2026-01-01": { 12: "New Years" },                    
    "2026-01-02": { 14: "move into Hmlet Shibuya ohashi" },
    "2026-01-07": { 14: { text: "attend ISI school orientation", tags: ["Japanese fluent"] } },
    "2026-02-01": { 14: { text: "move into Dash Living Yoyogi Uehara" } },
    "2026-02-20": { 13: { text: "check Japan COE result", tags: ["Japanese fluent"] } },
    "2026-03-01": { 13: { text: "release song that gets 1 million listens", tags: ["motion"] } },
    "2026-04-01": { 13: { text: "perform DJ set in venue that holds 50 people", tags: ["motion"] } },
    "2026-05-01": { 13: { text: "", tags: [""] } },
    "2026-06-01": { 13: { text: "", tags: [""] }, },
    "2026-06-11": { 13: { text: "watch World Cup game live", tags: [""] }, },
    "2026-07-05": { 13: { text: "pass JLPT N5 test", tags: ["Japanese fluent"] } },
    "2026-08-01": { 13: { text: "", tags: [""] } },
    "2026-09-01": { 13: { text: "", tags: [""] } },
    "2026-10-01": { 13: { text: "", tags: [""] } },
    "2026-11-01": { 13: { text: "", tags: [""] } },    
    "2026-12-01": { 17: { text: "dine at Chase OpenTable resturant for $150 Sapphire credit", tags: ["dumb rich"] } },
    "2027-01-02": { 13: { text: "achieve 500k net worth", tags: ["dumb rich"] } ,
                    14: { text: "join Chase private banking", tags: ["dumb rich"] } },
    "2028-01-02": { 13: { text: "", tags: [""] } },
    "2029-01-02": { 13: { text: "surgery to increase height to 6ft", tags: ["peak physique"] } },
    "2030-01-02": { 13: { text: "perform on EDC biggest stage", tags: ["motion"] } },
    "2031-01-03": { 13: { text: "propose to girlfriend", tags: ["love"] } },
    "2031-01-04": { 13: { text: "become one of Time magazine most influential people", tags: ["motion"] } },
    "2031-01-05": { 13: { text: "perform handstand", tags: ["peak physique"] } },
    "2032-01-02": { 13: "buy mom a house" },
    "2033-01-02": { 13: "snowboard in Dubai desert dunes" },
    "2034-01-02": { 13: "win hacker competition" },
    "2035-01-02": { 13: "kill animal with bow and arrow" },
    "2036-01-02": { 13: "own all stocks on market" },
    "2037-01-02": { 13: { text: "pass JLPT N4 test", tags: ["Japanese fluent"] } },
    "2037-02-02": { 13: { text: "become Tokyo Shinjuku top male host", tags: ["motion"] } },
    "2038-01-02": { 13: { text: "pass JLPT N3 test", tags: ["Japanese fluent"] } },
    "2039-01-02": { 13: { text: "pass JLPT N2 test", tags: ["Japanese fluent"] } },
    "2040-01-02": { 13: { text: "pass JLPT N1 test", tags: ["Japanese fluent"] } },
    "2041-01-02": { 13: "pass TOPIK test" },
    "2042-01-02": { 13: "become ambidextrous" },
    "2043-01-02": { 13: { text: "achieve 1 million net worth", tags: ["dumb rich"] } },
    "2044-01-02": { 13: "give shoulder rides for 3 person totem at rave" },
    "2045-01-02": { 13: "cosplay at convention" },
    "2046-01-02": { 13: "horseback ride and shoot arrow " },
    "2047-01-02": { 13: { text: "perform a split", tags: ["peak physique"] } },
    "2048-01-02": { 13: { text: "reach 1 million TikTok followers", tags: ["influence"] } },
    "2049-01-02": { 13: { text: "reach 1 million Youtube subscribers", tags: ["influence"] } },
    "2050-01-02": { 13: { text: "reach 1 million Twitch subscribers", tags: ["influence"] } },
    "2051-01-02": { 13: { text: "reach 1 million Instagram followers", tags: ["influence"] } },
    "2052-01-02": { 13: "do a backflip " },
    "2053-01-02": { 13: "be on cover of Vogue magazine" },
    "2054-01-02": { 13: "be guest on talk show" },
    "2055-01-02": { 13: "penis enlargement to 6 inches" },
    "2056-01-02": { 13: "buy place in Ginza Tokyo Japan" },
    "2057-01-02": { 13: "drive super-car" },
    "2058-01-02": { 13: "go surfing" },
    "2059-01-02": { 13: "be a model in a fashion show" },
    "2060-01-02": { 13: "swim with dolphins " },
    "2061-01-02": { 13: "walk on red carpet " },
    "2062-01-02": { 13: "have first kid" },
    "2063-01-02": { 13: "go sky diving" },
    "2064-01-02": { 13: "shoot sniper rifle" },
    "2065-01-02": { 13: "drive F1 car" },
    "2066-01-02": { 13: "publish book to be a best seller" },
    "2067-01-02": { 13: "drive speedboat" },
    "2068-01-02": { 13: "win a UFC belt" },
    "2069-01-02": { 13: "meet Jesus" },
    "2070-01-02": { 13: "run Triathalon" },
    "2071-01-02": { 13: "go hunting with guns" },
    "2072-01-02": { 13: "obtain degree from Harvard" },
    "2073-01-02": { 13: "be in a Redbull video" },
    "2074-01-02": { 13: "do a kickflip on skateboard" },
    "2075-01-02": { 13: "win streamer of the year" },
    "2076-01-02": { 13: "be elected president of USA" },
    "2077-01-02": { 13: "win a gold medal" },
    "2078-01-02": { 13: "explore bottom of the ocean" },
    "2079-01-02": { 13: "visit to space" },
    "2080-01-02": { 13: "visit every continent" },
    "2081-01-02": { 13: "win a Grammy" },
    "2082-01-02": { 13: "win an Oscar" },
    "2083-01-02": { 13: "fly a fighter jet" },
    "2084-01-02": { 13: "perform at concert" },
    "2085-01-02": { 13: "be a guest Joe Rogan podcast" },
    "2086-01-02": { 13: "win body building competition" },
    "2087-01-02": { 13: "drive military tank" },
    "2088-01-02": { 13: "obtain Korea pernament residency" },
    "2089-01-02": { 13: "shoot a bazooka" },
    "2090-01-02": { 13: "give a speech to 100,000 people" },
    "2091-01-02": { 13: "take a company IPO" },
    "2092-01-02": { 13: "retire mom" },
    "2093-01-02": { 13: "retire dad" },
    "2094-01-02": { 13: "retire sister" },
    "2095-01-02": { 13: "become an actor in a box office movie with 1 million earnings" },
    "2096-01-02": { 13: "bury mom" },
    "2097-01-02": { 13: "visit tomb of Jesus Christ" },
    "2098-01-02": { 13: "achieve 1 billion net worth" },
    "2099-01-02": { 13: "see the Northern lights" },
    "2100-01-02": { 13: "solve aging" },
    "2101-01-02": { 13: "swim in the Great Reefs" },
    "2102-01-02": { 13: "100k invested in real estate" },
    "2103-01-02": { 13: "achieve 10 million net worth" },
    "2104-01-02": { 13: "buy property in Singapore (South beach residences)" },
    "2105-01-02": { 13: "achieve 100 million net worth" },
    "2106-01-02": { 13: "achieve Marriott Lifetime Silver Elite Status" },
    "2107-01-02": { 13: "watch NBA all star game live" },
    "2108-01-02": { 13: "obtain Japan pernament residency" },
    "2109-01-02": { 13: "see a volcano" },
    "2110-01-02": { 13: "bury dad" },
    "2111-01-02": { 13: "explore a rainforest" },
    "2112-01-02": { 13: "enter art into musuem" },
    "2113-01-02": { 13: "fly first class" },
    "2114-01-02": { 13: "win nobel peace prize" },
    "2115-01-02": { 13: "go base jumping" },
    "2116-01-02": { 13: "enter my body into cryosleep" },  
  };

export default datedTasks;
